
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { Icon, NiceButton }
})
export default class UpgradeToProModal extends Vue {
  toggleDialog() {
    this.dialogOpen = !this.dialogOpen;
  }

  dialogOpen = false;
}
